module.exports = __webpack_public_path__ + "static/media/21ECLAC29.6baec2b4.jpg";